import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const effectivePrice = (p) =>
  p?.sale_price ? Number(p.sale_price) : Number(p?.regular_price || 0);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORY_OPTIONS = [
  { slug: "skincare", name: "Skincare" },
  { slug: "haircare", name: "Haircare" },
  { slug: "fragrance", name: "Fragrance" },
  { slug: "bath-body", name: "Bath & Body" },
  { slug: "jewellery", name: "Jewellery" },
  { slug: "accessories", name: "Accessories" },
];

export const categoryName = (slug) =>
  CATEGORY_OPTIONS.find((c) => c.slug === slug)?.name || slug;
